var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatGuidelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(6, 0)",
    d: "M18.8536 16.8536C19.0488 16.6583 19.0488 16.3417 18.8536 16.1464L15.6716 12.9645C15.4763 12.7692 15.1597 12.7692 14.9645 12.9645C14.7692 13.1597 14.7692 13.4763 14.9645 13.6716L17.7929 16.5L14.9645 19.3284C14.7692 19.5237 14.7692 19.8403 14.9645 20.0355C15.1597 20.2308 15.4763 20.2308 15.6716 20.0355L18.8536 16.8536ZM0.5 17H18.5V16H0.5V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGuidelineIcon);
export default __webpack_public_path__ + "static/media/chatGuidelineIcon.2f5da977aaf255c235dccaceddacd439.svg";
export { ForwardRef as ReactComponent };